import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import type { MarketingPage as MarketingPageType } from "../../types/domain";

type MarketingPageProps = {
  page: MarketingPageType;
};

export function MarketingPage({ page }: MarketingPageProps) {
  return (
    <main className="page-canvas">
      <section className="container marketing-hero">
        <div>
          <h1>{page.title}</h1>
          <p>{page.summary}</p>
          <div className="hero-actions light">
            <Link className="btn btn-primary" to="/ask">
              <span>{page.primaryAction}</span>
              <ArrowRight aria-hidden="true" />
            </Link>
            {page.secondaryAction ? (
              <Link className="btn btn-secondary-light" to="/contact">
                <span>{page.secondaryAction}</span>
              </Link>
            ) : null}
          </div>
        </div>
        <div className="marketing-visual">
          <span>{page.title.slice(0, 2).toUpperCase()}</span>
        </div>
      </section>
      <section className="container marketing-sections">
        {page.sections.map((section) => (
          <article className="marketing-section" key={section.title}>
            <h2>{section.title}</h2>
            <p>{section.body}</p>
            <ul>
              {section.points.map((point) => (
                <li key={point}>
                  <CheckCircle2 aria-hidden="true" />
                  {point}
                </li>
              ))}
            </ul>
          </article>
        ))}
      </section>
    </main>
  );
}
